export default {
  en_hk: { label: 'FIND A SALON' },
  en_id: { label: 'FIND A SALON' },
  en_my: { label: 'FIND A SALON' },
  en_sg: { label: 'FIND A SALON' },
  en: { label: 'FIND A SALON' },
  ja_jp: { label: 'サロン検索' },
  ko_kr: { label: 'ELITE CLUB' },
  th_th: { label: 'FIND A SALON' },
  zh_hk: { label: 'FIND A SALON' },
  zh_tw: { label: 'FIND A SALON' },
};



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/data/sitemapInfo.js